// extracted by mini-css-extract-plugin
module.exports = {"bulletPointList":"LoyaltyCard_bulletPointList__3y6JT","actionsWrapper":"LoyaltyCard_actionsWrapper__1USB-"};